import React, { useState } from 'react';
import { Alert, Form, Modal } from 'react-bootstrap';
import type { CheckRow } from '../../../../../Helpers/componentChecks';

interface CheckDueDateModalProps {
    row: CheckRow;
    onSave: (nextDueDate: string) => Promise<boolean>;
    onClose: () => void;
}

/**
 * Move the next due date of a draft Kontroller row: one check, or in
 * Massredigering the template's checks on every selected component.
 */
export const CheckDueDateModal: React.FC<CheckDueDateModalProps> = ({ row, onSave, onClose }) => {
    const first = row.checks.map(check => check.instance.nextDueDate).sort()[0] ?? '';
    const [date, setDate] = useState((row.nextDueDate ?? first).substring(0, 10));
    const [saving, setSaving] = useState(false);
    const several = row.checks.length > 1;

    const handleSave = async () => {
        setSaving(true);
        const saved = await onSave(date);
        setSaving(false);
        if (saved) onClose();
    };

    return (
        <Modal show onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Nästa datum</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="mb-3"><strong>{row.name}</strong></p>
                <Form.Group controlId="check-next-due-date">
                    <Form.Label>Nästa förfallodatum</Form.Label>
                    <Form.Control type="date" value={date} onChange={e => setDate(e.target.value)} />
                </Form.Group>
                {several && (
                    <Alert variant="info" className="mt-3 mb-0">
                        Datumet sätts på alla {row.checks.length} kontroller{row.nextDueDate ? '' : ', som i dag har olika datum'}.
                    </Alert>
                )}
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-secondary" onClick={onClose} disabled={saving}>
                    Avbryt
                </button>
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSave}
                    disabled={saving || !date || date === row.nextDueDate}
                >
                    {saving ? 'Sparar…' : 'Spara'}
                </button>
            </Modal.Footer>
        </Modal>
    );
};
